(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').factory('apConfirm', [
        '$uibModal',
        apConfirm
    ]);

    function apConfirm(
        $modal
    ) {

        return open;

        function open(message, okText, cancelText, size) {
            var confirmModal = $modal.open({
                controller: [
                    '$uibModalInstance',
                    'message',
                    'okText',
                    'cancelText',
                    ApConfirmCtrl
                ],
                controllerAs: 'vm',
                backdrop: 'static',
                templateUrl: '/core-ui/views/confirm.html',
                size: size || 'sm', // xs, sm, md, lg
                resolve: {
                    message: function() {
                        return message;
                    },
                    okText: function() {
                        return okText;
                    },
                    cancelText: function() {
                        return cancelText;
                    },
                },
            });

            return confirmModal.result;
        }
    }

    function ApConfirmCtrl(
        $modalInstance,
        message,
        okText,
        cancelText
    ) {
        var vm = this;

        vm.message = message;
        vm.okText = okText || 'OK';
        vm.cancelText = cancelText || 'Cancel';
        vm.cancel = cancel;
        vm.close = close;

        function cancel() {
            $modalInstance.dismiss();
        }

        function close(value) {
            $modalInstance.close(value);
        }
    }

})(window.angular);
